// =============== CJ VARIANT WRAPPER — MIN (red selection for ALL) ===============
(function () {
  const EXCLUSIVE = false; // multi-open

  // ---- helpers -------------------------------------------------------------
  function cleanLabelText(labelEl) {
    if (!labelEl) return '';
    const c = labelEl.cloneNode(true);
    c.querySelectorAll('.visually-hidden,[aria-hidden="true"],[data-product-status],.product-form__inventory,.product__inventory,.product-form__variant-status').forEach(n=>n.remove());
    return c.textContent.replace(/Variant\s+sold\s+out\s+or\s+unavailable/gi,'').replace(/\s+/g,' ').trim();
  }
  function optionTitle(group){
    const el = group.querySelector('input[name^="options["],select[name^="options["]');
    if (el?.name){
      const m = el.name.match(/^options\[(.+)\]/i);
      if (m?.[1]) return m[1];
    }
    const t = group.querySelector('legend, label');
    return (t ? t.textContent : 'Options').trim().split(/\s*[:\-\u2013\u2014]\s*/)[0];
  }
  function currentValue(group){
    const r = group.querySelector('input[type="radio"]:checked');
    if (r){
      const lab = r.nextElementSibling;
      return cleanLabelText(lab) || r.value || '';
    }
    const s = group.querySelector('select');
    if (s){
      const txt = s.options[s.selectedIndex]?.text || '';
      return txt.replace(/Variant\s+sold\s+out\s+or\s+unavailable/gi,'').trim();
    }
    return '';
  }
  const metalOf = (lc) => {
    if (/(white|blanc)/.test(lc)) return 'white-gold';
    if (/(yellow|jaune)/.test(lc)) return 'yellow-gold';
    if (/rose/.test(lc)) return 'rose-gold';
    return '';
  };
  const paintDot = (el, metal) => {
    const hl = 'radial-gradient(circle at 30% 30%, rgba(255,255,255,.9) 0 35%, rgba(255,255,255,0) 36%), ';
    let bg = hl + 'linear-gradient(180deg,#f3f4f6,#d1d5db)', br = '#cfd3d8';
    if (metal === 'white-gold'){ bg = hl + 'linear-gradient(180deg,#f7f9fb, #cfd5dc)'; br = '#c7ccd3'; }
    else if (metal === 'yellow-gold'){ bg = hl + 'linear-gradient(180deg,#ffeaa7, #d4af37)'; br = '#d9b74a'; }
    else if (metal === 'rose-gold'){ bg = hl + 'linear-gradient(180deg,#ffd6db, #e4a6b2)'; br = '#d9a0a8'; }
    el.style.cssText = 'display:inline-block;width:12px;height:12px;border-radius:50%;margin-right:8px;vertical-align:-2px;background:'+bg+';border:1px solid '+br+';';
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-form__input').forEach(group => {
      if (group.dataset.cjWrapped === '1') return;

      const title = optionTitle(group);
      const isColor = /color|couleur/i.test(title);

      // ---- shell .cj-opt ---------------------------------------------------
      const wrap = document.createElement('div');
      wrap.className = 'cj-opt';
      if (isColor) wrap.setAttribute('data-color','true');
      wrap.setAttribute('data-open','false');

      const head = document.createElement('div'); head.className = 'cj-head';
      const chev = document.createElement('span'); chev.className='cj-chev';
      const tEl = document.createElement('div'); tEl.className='cj-title'; tEl.textContent = title;
      const vEl = document.createElement('div'); vEl.className='cj-value';
      head.append(chev, tEl, vEl);

      const divider = document.createElement('div'); divider.className='cj-divider';
      const grid = document.createElement('div'); grid.className='cj-grid';
      const parent = group.parentNode;
      parent.insertBefore(wrap, group);
      wrap.append(head, divider, grid);
      grid.appendChild(group);

      // ---- header value (dot + texte pour Color) ---------------------------
      const renderHeaderValue = () => {
        const val = currentValue(group);
        if (!isColor){ vEl.textContent = val; return; }
        const selLab = group.querySelector('input[type="radio"]:checked + label');
        let metal = selLab?.getAttribute('data-metal') || metalOf((val||'').toLowerCase());
        vEl.innerHTML = '';
        const dot = document.createElement('i'); dot.className = 'cj-value-dot'; paintDot(dot, metal);
        const txt = document.createElement('span'); txt.textContent = val;
        vEl.append(dot, txt);
      };

      // ---- style sélection rouge (POUR TOUS les groupes) -------------------
      const applySelectedStyle = (lab, isSel) => {
        const force = (p,v)=> lab.style.setProperty(p,v,'important');
        const isColorLabel = lab.closest('.cj-opt')?.getAttribute('data-color') === 'true';

        if (isSel){
          // sélection -> rouge + texte blanc (inline pour battre l'app)
          force('background','#B72621');
          force('border','1px solid #B72621');
          force('color','#fff');
        } else {
          // non sélection -> revenir à l'état de base
          if (isColorLabel){
            // Color a un style de base forcé (blanc)
            force('background','#fff');
            force('border','1px solid #e1e5ea');
            force('color','#111');
          } else {
            // autres options : on enlève les overrides pour laisser le thème décider
            lab.style.removeProperty('background');
            lab.style.removeProperty('border');
            lab.style.removeProperty('color');
          }
        }
        lab.dataset.selected = isSel ? 'true' : 'false';
      };

      // ---- armer un label (Color = dot + texte ; autres = normal) ----------
      const armLabel = (lab, inp) => {
        // tous les labels sont des .cj-pill
        lab.classList.add('cj-pill','cj-armed');

        if (isColor){
          const txt = (lab.getAttribute('title') || inp.getAttribute('value') || cleanLabelText(lab)).trim();
          const lc  = txt.toLowerCase();
          lab.dataset.color = lc;

          // force base “pill”
          const force = (p,v)=> lab.style.setProperty(p,v,'important');
          force('display','inline-flex'); force('align-items','center'); force('justify-content','flex-start');
          force('flex-direction','row');  force('gap','10px');           force('padding','10px 14px');
          force('width','auto');          force('height','auto');        force('min-width','0'); force('min-height','0');
          force('background','#fff');     force('background-image','none');
          force('border','1px solid #e1e5ea'); force('border-radius','12px');
          force('box-shadow','0 1px 2px rgba(0,0,0,.04)'); force('white-space','nowrap'); force('overflow','visible');
          force('font-weight','400');

          const metal = metalOf(lc);
          lab.setAttribute('data-metal', metal);

          // contenu = dot réel + texte
          lab.textContent = '';
          const dot = document.createElement('i'); dot.className = 'cj-dot-el'; paintDot(dot, metal);
          const tspan = document.createElement('span'); tspan.className='cj-text'; tspan.textContent = txt;
          lab.append(dot, tspan);
        }

        applySelectedStyle(lab, inp.checked);
      };

      // ---- radios ----------------------------------------------------------
      group.querySelectorAll('input[type="radio"]').forEach((inp) => {
        const lab = inp.nextElementSibling;
        if (!(lab && lab.tagName === 'LABEL')) return;
        if (!lab.classList.contains('cj-armed')) armLabel(lab, inp);

        inp.addEventListener('change', () => {
          group.querySelectorAll('input[type="radio"]').forEach(i2 => {
            const l2 = i2.nextElementSibling; if (l2) applySelectedStyle(l2, i2.checked);
          });
          renderHeaderValue();
        });
      });

      // ---- select (au cas où) ----------------------------------------------
      const sel = group.querySelector('select');
      if (sel) sel.addEventListener('change', ()=> renderHeaderValue());

      // ---- header initial ---------------------------------------------------
      renderHeaderValue();

      // ---- toggle open/close -----------------------------------------------
      head.addEventListener('click', ()=>{
        const open = wrap.getAttribute('data-open') === 'true';
        if (EXCLUSIVE){
          document.querySelectorAll('.cj-opt[data-open="true"]').forEach(w=>{ if (w!==wrap) w.setAttribute('data-open','false'); });
        }
        wrap.setAttribute('data-open', open ? 'false' : 'true');
      });

      // ---- re-arm si l’app réécrit les labels ------------------------------
      new MutationObserver(() => {
        group.querySelectorAll('input[type="radio"]').forEach(inp => {
          const lab = inp.nextElementSibling;
          if (lab && lab.tagName === 'LABEL' && !lab.classList.contains('cj-armed')){
            armLabel(lab, inp);
          } else if (lab){
            applySelectedStyle(lab, inp.checked);
          }
        });
        renderHeaderValue();
      }).observe(group, {subtree:true, childList:true, characterData:true});

      group.dataset.cjWrapped = '1';
    });
  });
})();



// === CJ ATC GLUE — no styles touched ===
(function(){
  // Guard for older templates
  function getProductJSON(){
    const s = document.querySelector('script[type="application/json"][data-product]');
    if(!s) return null;
    try { return JSON.parse(s.textContent); } catch(e){ return null; }
  }
  function norm(str){
    return String(str||'')
      .replace(/\u2033/g, '"') // ″ -> "
      .replace(/\u00A0/g, ' ') // NBSP -> space
      .trim();
  }

  const product = getProductJSON();
  const optionNames = product?.options?.map(norm) || [];

  function getForm(){
    return document.querySelector('product-form form, form[action*="/cart/add"]');
  }

  function readSelectedNative(form){
    return optionNames.map(n => {
      const r = form.querySelector(`input[name="options[${CSS.escape(n)}]"]:checked`);
      if (r) return norm(r.value);
      const s = form.querySelector(`select[name="options[${CSS.escape(n)}]"]`);
      if (s) return norm(s.value);
      return "";
    });
  }
  function readSelectedFromCJ(){
    const values = Array(optionNames.length).fill("");
    document.querySelectorAll('.cj-opt').forEach(opt=>{
      const native = opt.querySelector('.cj-grid input[name^="options["], .cj-grid select[name^="options["]');
      if(!native || !native.name) return;
      const m = native.name.match(/^options\[(.+)\]$/i);
      const official = m ? norm(m[1]) : "";
      const idx = optionNames.findIndex(o => o === official);
      if (idx < 0) return;
      const sel = opt.querySelector('.cj-pill[data-selected="true"]');
      if (!sel) return;
      const t = sel.querySelector('.cj-text');
      values[idx] = norm(t ? t.textContent : sel.textContent);
    });
    return values;
  }
  function findVariant(values){
    if (!product) return null;
    for (const v of (product.variants||[])){
      if (!v || !v.options || v.options.length !== values.length) continue;
      let ok = true;
      for (let i=0;i<values.length;i++){
        if (norm(v.options[i]) !== norm(values[i])) { ok=false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function sync(){
    const form = getForm(); if(!form) return;
    // 1) lire natif; si trou, combler avec CJ
    let vals = readSelectedNative(form);
    if (vals.some(v=>!v)) {
      const cjVals = readSelectedFromCJ();
      vals = vals.map((v,i)=> v || cjVals[i] || "");
    }
    // 2) variante + MAJ id + ATC
    const variant = findVariant(vals);
    const idInput = form.querySelector('input[name="id"]');
    const atc     = form.querySelector('[type="submit"]');
    if (variant && idInput) idInput.value = String(variant.id);
    if (atc) {
      const canBuy = !!(variant && variant.available);
      atc.disabled = !canBuy;
      if (canBuy){ atc.removeAttribute('aria-disabled'); atc.classList.remove('disabled'); }
      else       { atc.setAttribute('aria-disabled','true'); atc.classList.add('disabled'); }
    }
  }

  // 1) Clic sur un pill -> cocher le radio natif + event 'change'
  document.addEventListener('click', (e)=>{
    const pill = e.target.closest('.cj-pill');
    if (!pill) return;
    let input = pill.previousElementSibling;
    if (!(input && input.tagName === 'INPUT')) {
      const fid = pill.getAttribute('for');
      if (fid) input = document.getElementById(fid);
    }
    if (input && (input.type === 'radio' || input.type === 'checkbox')) {
      if (!input.checked) input.checked = true;
      // Notifie le web component du thème
      input.dispatchEvent(new Event('change', {bubbles:true}));
      // Safety: recalcul après la mise à jour du thème
      requestAnimationFrame(sync);
    } else {
      requestAnimationFrame(sync);
    }
  }, {passive:true});

  // 2) Changement natif (radios/selects) -> resync
  document.addEventListener('change', (e)=>{
    const name = e.target?.name || '';
    if (/^options\[[^\]]+\]$/.test(name)) requestAnimationFrame(sync);
  }, true);

  // 3) Si ton script flippe data-selected sans changer le radio (cas rare)
  const obs = new MutationObserver(muts=>{
    if (muts.some(m=>m.type==='attributes' && m.attributeName==='data-selected')) {
      requestAnimationFrame(sync);
    }
  });
  obs.observe(document.body, {subtree:true, attributes:true, attributeFilter:['data-selected']});

  // 4) Initial
  sync();
})();
